


































import { defineComponent, computed, toRefs, PropType } from '@vue/composition-api';
import Container from '@/components/main/Container.vue';
import useStore from '@/mixins/useStore';

interface TabsItem {
    name: string;
    label: string | ((h: any) => any);
    isShowTabsPane: boolean;
    tab?: string;
}

export default defineComponent({
    name: 'TabsLayout',
    components: {
        Container,
    },
    props: {
        // tabsList属性
        tabsList: {
            type: Array as PropType<TabsItem[]>,
            default: () => ([]),
        },
        value: {
            type: String,
            default: '',
            required: true,
        },
        // 模式
        mode: {
            type: String as PropType<'router' | 'component'>,
            default: 'router',
        },
        // Contain组件下的div样式
        boxPageStyle: {
            type: Object as PropType<any>,
            default: () => ({}),
        },
        // 是否展示Tabs
        showTabs: {
            type: Boolean,
            default: true,
        },
    },
    setup(props, ctx) {
        const { emit } = ctx;
        const { value } = toRefs(props);
        const { userModule, companyModule } = useStore();

        const { auth_technology_status } = companyModule.useState(['auth_technology_status']);

        const { roleId, isOwner } = userModule.useState(['roleId', 'isOwner']);

        const remoteTechnologyStatus = computed(() => {
            return (
                auth_technology_status.value === '1' &&
                ['0', '1'].indexOf(roleId.value) !== -1
            );
        });

        const containerStyle = computed(() => {
            if (remoteTechnologyStatus.value && isOwner.value === '0') {
                return {
                    height: 'calc(100vh - 100px)',
                };
            }
            if (remoteTechnologyStatus.value || isOwner.value === '0') {
                return {
                    height: 'calc(100vh - 80px)',
                };
            }
            return {};
        });

        const tabs = computed({
            get() {
                return value.value;
            },
            set(val: string) {
                emit('input', val);
            },
        });

        const onTabChange = (name: string) => {
            emit('on-tab-change', name);
        };

        const onCancelSwitch = (name: string) => {
            emit('on-cancel-switch', name);
        };

        return {
            tabs,
            containerStyle,
            onTabChange,
            onCancelSwitch,
        };
    },
});
